import { acceptHMRUpdate, defineStore } from 'pinia';

interface State {
  error?: unknown;
}

export const useErrorStore = defineStore('error', {
  state: (): State => {
    return {
      error: undefined,
    };
  },

  getters: {
    hasError: (state) => state.error !== undefined,
  },

  actions: {
    setError(error: unknown) {
      this.error = error;
    },
  },
});

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useErrorStore, import.meta.hot));
